import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./Support.scss";
import { Box, Button, Collapse, Link } from "@mui/material";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import TextArea from "../../../../Supporting files/TextArea/TextArea";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import FAQ from "./FAQ/FAQ";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function Support() {
  const [reason, setReason] = React.useState("");
  const [uploadFile, setUploadFile] = React.useState("");
  const [reasonForSupport, setReasonForSupport] = React.useState("");

  const reason_data = [
    { label: "Maruti Suzuki", value: "Maruti Suzuki" },
    { label: "Hyundai", value: "Hyundai" },
    { label: "Tata", value: "Tata" },
  ];

  const faqs = [
    {
      expanded: "panel1",
      title: "How to raise a request for claim intimation?",
      description:
        "Reach out to your insurance company as soon as possible to inform them about the incident or event that may lead to a claim. You can find their contact information on your insurance policy documents or their website.",
    },
    {
      expanded: "panel2",
      title: "How to update password?",
      description: "kdsgjsdkjgkdsjgksd dskgsdkgs gksdjgk",
    },
    {
      expanded: "panel3",
      title: "What is riskmap?",
      description:
        "A risk score map is a visual representation or a graphical representation that indicates the level of risk associated with different areas or regions. It is used to identify and communicate the varying degrees of risk across a specific geographical area or within a particular domain.",
    },
    {
      expanded: "panel4",
      title: "How does group health insurance policy work?",
      description:
        "An employer purchases a group healthcare coverage plan for their respective employees based on the number of workers. The employer entirely bears the cost of group healthcare. In return, the employees can avail medical insurance as per the sum insured.",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const [status, setStatus] = useState(false);

  return (
    <Grid xs className="supportWrapper">
      <Grid container spacing={3}>
        <Grid xs={12} className="pageTitle">
          <h2>
            <span>Get</span> Support
          </h2>
          <p>
            What incredible experiences are unfolding within you? Kindly grace
            us with the gift of sharing.
          </p>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={8}>
          <Grid container spacing={3}>
            <Grid xs={4}>
              <img src="./images/confused.svg" />
            </Grid>
            <Grid xs={8}>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Reason of writing to us"
                    value={reason}
                    attrName={setReason}
                    value_update={updateMasterState}
                    data={reason_data}
                    warn_status={false}
                    error_message={"please select type"}
                  />
                </Grid>
                <Grid xs={12}>
                  <TextArea
                    class_name="inputField multiline"
                    title={"Describe Here"}
                    value={reasonForSupport}
                    attrName={setReasonForSupport}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={12} className="px-0">
                  <Grid container spacing={0} className="uploadFile">
                    <Grid xs={10} className="inputField">
                      <RKTextField
                        class_name="inputField"
                        title={"Upload .jpg .png .pdf file"}
                        value={uploadFile}
                        attrName={setUploadFile}
                        value_update={updateMasterState}
                        warn_status={false}
                        disable={true}
                      />
                    </Grid>
                    <Grid xs={2}>
                      <Button
                        variant="contained"
                        className="browsebtn"
                        component="label"
                      >
                        Browse
                        <input hidden accept="image/*" type="file" />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid xs={12} className="ctaBtn">
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {}}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid xs={12} className="subHeading">
              <h3>
                <span>General</span> Questions
              </h3>
              <p>
                You will discover the solutions you seek. Our mission is to
                offer a seamless and user-friendly experience, ensuring that you
                can access valuable information promptly to address your
                frequently asked questions.
              </p>
            </Grid>
            <Grid xs={12}>
              {faqs.map((data, index) => {
                return (
                  <FAQ
                    data={{
                      description: data.description,
                      expanded: data.expanded,
                      title: data.title,
                    }}
                  />
                );
              })}
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid xs={4} className="requestSection">
          <Box textAlign="center">
            <img src="./images/no-requests.svg" />
            <p>No Request Pending</p>
          </Box>
          <ul className="requestList">
            <li>
              <Collapse in={status} collapsedSize={80} className="cancelled">
                <h6>#BE84678</h6>
                <span className="status">Pending</span>
                <h5>Claim Request Initiate</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  facilisis metus nec ex ullamcorper, ac ultrices elit aliquam.
                  Fusce eleifend, enim ac sollicitudin lobortis, elit felis
                  aliquam sapien, vel ullamcorper tortor elit non turpis.
                </p>
                <Link className="viewMore" onClick={() => setStatus(!status)}>
                  <ExpandMoreIcon />
                </Link>
              </Collapse>
            </li>
            <li>
              <Collapse in={status} collapsedSize={80} className="inprogress">
                <h6>#BE84678</h6>
                <span className="status">In-Progress</span>
                <h5>Claim Request Initiate</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  facilisis metus nec ex ullamcorper, ac ultrices elit aliquam.
                  Fusce eleifend, enim ac sollicitudin lobortis, elit felis
                  aliquam sapien, vel ullamcorper tortor elit non turpis.
                </p>
                <Link className="viewMore" onClick={() => setStatus(!status)}>
                  <ExpandMoreIcon />
                </Link>
              </Collapse>
            </li>
            <li>
              <Collapse in={status} collapsedSize={80} className="approved">
                <h6>#BE84678</h6>
                <span className="status">In-Progress</span>
                <h5>Endorsement</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
                  facilisis metus nec ex ullamcorper, ac ultrices elit aliquam.
                  Fusce eleifend, enim ac sollicitudin lobortis, elit felis
                  aliquam sapien, vel ullamcorper tortor elit non turpis.
                </p>
                <Link className="viewMore" onClick={() => setStatus(!status)}>
                  <ExpandMoreIcon />
                </Link>
              </Collapse>
            </li>
          </ul>
        </Grid> */}
      </Grid>
    </Grid>
  );
}

export default Support;
